import React from 'react'

class DetailRow extends React.Component {
  render() {
    const {
      title,
      children,
    } = this.props;

    return(
      <div className='big d-sm-flex justify-content-between border-bottom p-3'>
        <div className='grey'>{ title }</div>
        { children }
      </div>
    )
  }
}

export default DetailRow
